import React, { useState } from "react";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import "utils/dayjsPlugins";

// interface RHFDatePickerFieldProps {
//   control: Control<any>;
//   name: string;
//   placeholder?: string;
// }

const DATE_FORMAT = "MM/DD/YYYY";

// antd DatePicker parity: read-only input that opens the calendar popover on
// click (DesktopDatePicker, so touch devices get the same popover rather than
// MUI's mobile dialog), a "Today" shortcut, MM/DD/YYYY display; the form value is the picked
// dayjs object (or null when cleared).
const RCDatePickerInput = ({ field, fieldState, placeholder }) => {
  const [open, setOpen] = useState(false);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        value={field.value ? dayjs(field.value) : null}
        format={DATE_FORMAT}
        onChange={(date) => {
          field.onChange(date ? date : null);
        }}
        slotProps={{
          textField: {
            name: field.name,
            inputRef: field.ref,
            placeholder,
            size: "small",
            error: Boolean(fieldState.error),
            readOnly: true,
            onClick: () => setOpen(true),
            onBlur: field.onBlur,
            sx: {
              "& .MuiInputBase-input": { fontSize: 14 },
              "& .MuiInputBase-root": { pr: 1 },
            },
          },
          // antd's footer had a "Today" shortcut.
          actionBar: { actions: ["today"] },
        }}
      />
    </LocalizationProvider>
  );
};

const RCDatePickerField = (props) => {
  return (
    <Controller
      control={props.control}
      name={props.name}
      rules={{
        required: "This field is required",
      }}
      render={({ field, fieldState }) => {
        return (
          <>
            <RCDatePickerInput
              field={field}
              fieldState={fieldState}
              placeholder={props.placeholder}
            />
            <br />
            {fieldState.error ? (
              <span style={{ color: "red" }}>{fieldState.error?.message}</span>
            ) : null}
          </>
        );
      }}
    />
  );
};

export default React.memo(RCDatePickerField);
